// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_ORGANIZATION_TYPE,
	SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS,
	SETTING_UPDATE_ORGANIZATION_TYPE,
	SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS,
	SETTING_LOAD_ORGANIZATION_TYPE,
	SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS,
	SETTING_DELETE_ORGANIZATION_TYPE,
	SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS,

	SETTING_LOAD_ORGANIZATION,
	SETTING_LOAD_ORGANIZATION_SUCCESS,
	SETTING_CREATE_ORGANIZATION,
	SETTING_CREATE_ORGANIZATION_SUCCESS,
	SETTING_UPDATE_ORGANIZATION,
	SETTING_UPDATE_ORGANIZATION_SUCCESS,
	SETTING_DELETE_ORGANIZATION,
	SETTING_DELETE_ORGANIZATION_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_CUSTOMER,
	SETTING_LOAD_CUSTOMER_SUCCESS,
	SETTING_CREATE_CUSTOMER,
	SETTING_CREATE_CUSTOMER_SUCCESS,
	SETTING_UPDATE_CUSTOMER,
	SETTING_UPDATE_CUSTOMER_SUCCESS,
	SETTING_DELETE_CUSTOMER,
	SETTING_DELETE_CUSTOMER_SUCCESS,
	// SETTING_UPDATE_CUSTOMER_STATUS,
	// SETTING_UPDATE_CUSTOMER_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	organizationTypeLoading: false,
	organizationLoading: false,
	customerLoading: false,
	organizationType: [],
	optionOrganizationType: [],
	organization: [],
	optionOrganization: [],
	customer: [],
	optionCustomer: [],

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_ORGANIZATION_TYPE:
			return { ...state, organizationTypeLoading: true, }
		case SETTING_LOAD_ORGANIZATION_TYPE_SUCCESS:
			return {
				...state,
				organizationTypeLoading: false,
				organizationType: action.payload,
				optionOrganizationType: action.payloadlist
			}
		case SETTING_CREATE_ORGANIZATION_TYPE:
			return { ...state, organizationTypeLoading: true }
		case SETTING_CREATE_ORGANIZATION_TYPE_SUCCESS:
			return { ...state, organizationTypeLoading: false }
		case SETTING_UPDATE_ORGANIZATION_TYPE:
			return { ...state, organizationTypeLoading: true }
		case SETTING_UPDATE_ORGANIZATION_TYPE_SUCCESS:
			return { ...state, organizationTypeLoading: false }
		case SETTING_DELETE_ORGANIZATION_TYPE:
			return { ...state, organizationTypeLoading: true }
		case SETTING_DELETE_ORGANIZATION_TYPE_SUCCESS:
			return { ...state, organizationTypeLoading: false }
		case SETTING_LOAD_ORGANIZATION:
			return { ...state, organizationLoading: true, }
		case SETTING_LOAD_ORGANIZATION_SUCCESS:
			return {
				...state,
				organizationLoading: false,
				organization: action.payload,
				optionOrganization: action.payloadlist
			}
		case SETTING_CREATE_ORGANIZATION:
			return { ...state, organizationLoading: true }
		case SETTING_CREATE_ORGANIZATION_SUCCESS:
			return { ...state, organizationLoading: false }
		case SETTING_UPDATE_ORGANIZATION:
			return { ...state, organizationLoading: true }
		case SETTING_UPDATE_ORGANIZATION_SUCCESS:
			return { ...state, organizationLoading: false }
		case SETTING_DELETE_ORGANIZATION:
			return { ...state, organizationLoading: true }
		case SETTING_DELETE_ORGANIZATION_SUCCESS:
			return { ...state, organizationLoading: false }
		case SETTING_LOAD_CUSTOMER:
			return { ...state, customerLoading: true, }
		case SETTING_LOAD_CUSTOMER_SUCCESS:
			return {
				...state,
				customerLoading: false,
				customer: action.payload,
				optionCustomer: action.payloadlist
			}
		case SETTING_CREATE_CUSTOMER:
			return { ...state, customerLoading: true }
		case SETTING_CREATE_CUSTOMER_SUCCESS:
			return { ...state, customerLoading: false }
		case SETTING_UPDATE_CUSTOMER:
			return { ...state, customerLoading: true }
		case SETTING_UPDATE_CUSTOMER_SUCCESS:
			return { ...state, customerLoading: false }
		case SETTING_DELETE_CUSTOMER:
			return { ...state, customerLoading: true }
		case SETTING_DELETE_CUSTOMER_SUCCESS:
			return { ...state, customerLoading: false }
		// case SETTING_UPDATE_CUSTOMER_STATUS:
		// 	return { ...state, customerLoading: true }
		// case SETTING_UPDATE_CUSTOMER_STATUS_SUCCESS:
		// 	return { ...state, customerLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				organizationTypeLoading: false,
				organizationLoading: false,
				customerLoading: false,
				organizationType: [],
				optionOrganizationType: [],
				organization: [],
				optionOrganization: [],
				customer: [],
				optionCustomer: [],
			};

		default: return { ...state };
	}
}